"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Shows buttons for register and login
 * @param {ButtonsProps} props
 * @returns {JSX.Element}
 */
const Buttons = ({
  registerLink,
  signInLink
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.BUTTONS),
    children: [registerLink?.relativeUrl && registerLink.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Button, {
      "data-testid": getTestId(_constants.REGISTER_BUTTON),
      href: registerLink.relativeUrl,
      variant: "contained",
      color: "primary",
      children: registerLink.title
    }) : null, signInLink?.relativeUrl && signInLink.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Button, {
      "data-testid": getTestId(_constants.LOGIN_BUTTON),
      variant: "contained",
      color: "secondary",
      onClick: _utils.openLogin,
      children: signInLink.title
    }) : null]
  });
};
exports.Buttons = Buttons;
